import React from "react";

const PaperAcceptanceTable = ({ tableDataSet }) => {
  return (
    <div className="w-full flex flex-col border-[2px] border-secondary rounded-[0.5em] overflow-hidden shadow-sm shadow-bg4 max-w-[1500px] m-auto">
      <div className="flex bg-secondary text-tertiary font-semibold divide-x-2 divide-white">
        <div className="flex-1 text-center py-[0.8em]">
          Season
        </div>
        <div className="flex-1 text-center py-[0.8em]">
          Acceptance Ratio
        </div>
      </div>

      {tableDataSet.map((item, index) => (
        <div
          key={index}
          className="flex border-b border-gray-200 divide-x-2 divide-gray-300 text-[0.8em]"
        >
          <div className="flex-1 text-center py-[0.5em] px-[0.2em] font-semibold bg-bg4 text-secondary">
            {item.season}
          </div>

          <div className="flex-1 text-center py-[0.5em] px-[0.5em] font-semibold">
            {item.acceptanceRatio}
          </div>
        </div>
      ))}
    </div>
  );
};

export default PaperAcceptanceTable;